import {Dimensions, StyleSheet} from 'react-native';
const {width} = Dimensions.get('window');

const Colors = {
  mBackColor: '#efefef',
  mBorderColor: '#efefef',
  white: '#FFFFFF',
  shadowColor: '#A69E9E',
};

const Metrics = {
  containerWidth: width - 30,
  switchWidth: width / 2.7,
};
export default StyleSheet.create({
  formContainer: {
    padding: 8,
    flex: 1,
  },

  containers: {
    width: Metrics.containerWidth,
    height: 55,
    flexDirection: 'row',
    backgroundColor: Colors.mBackColor,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: Colors.mBorderColor,
    borderRadius: 27.5,
  },
  button: {
    margin: 15,
    color: '#fff',
    padding: 10,
    paddingLeft: 30,
    paddingRight: 30,
    backgroundColor: '#69bbea',
  },
  container: {
    marginVertical: 8,
  },
  input: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 5,
    paddingVertical: 5,
    paddingLeft: 5,
    fontSize: 16,
    height: 40,
    color: '#c0cbd3',
  },
  info: {
    backgroundColor: '#0F579E',
    marginHorizontal: 6,
    maxWidth: 18,
    height: 18,
    width: 18,
    borderRadius: 10,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 0,
    paddingHorizontal: 2,
    fontSize: 16,
  },
  colorWhite: {
    zIndex: 9999,
    color: 'white',
  },
  App: {
    textAlign: 'left',
    paddingTop: 10,
  },
  label: {
    marginTop: 15,
    marginBottom: 15,
    fontSize: 16,
    fontWeight: '400',
    color: 'black',
    height: 20,
    lineHeight: 20,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    zIndex: 20,
  },
  bold: {
    fontWeight: 'bold',
  },
  textError: {
    color: '#f00',
    fontSize: 14,
  },
  item: {
    marginBottom: 14,
  },
});
